module.exports = __webpack_public_path__ + "img/FLSH10.666e00bd.svg";